/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if(window.boostSDAppConfig){
  window.boostSDAppConfig.filterSettings.showLoading = false;
}

const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                    var images = productData.images_info;
                    setTimeout(() => {
                     const firstImageSrc = productItem.querySelector(".boost-sd__product-image-img--main").src
                       let firstImage = productData.images_info.filter(e => e.src.includes(firstImageSrc))
                      console.log(firstImage)
                     
                      var newSecondImage = images.find(image => image.position == firstImage[0].position + 1 );
                       console.log(newSecondImage)
                    
                      if(newSecondImage != null){
                        console.log(productItem.querySelector(".boost-sd__product-image-img--second").src)
                        setTimeout(() => {
                          productItem.querySelector(".boost-sd__product-image-img--second").src = newSecondImage.src
                          productItem.querySelector(".boost-sd__product-image-img--second").srcset = newSecondImage.src
                          }, "0");
                      }
                                       
              }, "500");
                 }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);